import { useQuery } from '@tanstack/react-query';

import UsersService from '~/services/UsersService';

export const listUsersQueryKeys = {
  all: ['list-users'] as const,
  list: (search: string, brand: string) => [...listUsersQueryKeys.all, search, brand] as const,
};

export function useListUsers(search: string, brand: string) {
  return useQuery({
    queryKey: listUsersQueryKeys.list(search, brand),
    queryFn: async () => {
      if (!search) {
        return [];
      }
      return await UsersService.getUsers({ filter: search, brand });
    },
    enabled: search.length > 0 && !!brand,
    staleTime: 30000, // Keep search results fresh for 30 seconds
  });
}
